import React from 'react';
import { darken, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import GenericButton, { GenericButtonTypeEnum } from './GenericButton';

interface GenericInfoModal {
  open: boolean;
  onClose: () => void;
  onConfirm?: () => void;
  label: string;
  message?: string;
  confirmLabel?: string;
  entityName?: string;
  children?: React.ReactNode;
  closeLabel?: string;
  confirmColor?: string;
}

const GenericInfoModal: React.FC<GenericInfoModal> = ({
  open,
  onClose,
  onConfirm,
  label,
  message,
  confirmLabel,
  entityName,
  children,
  closeLabel,
  confirmColor
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      slotProps={{
        paper: {
          sx: { p: 2, borderRadius: '10px' },
          elevation: 3
        },
        backdrop: {
          sx: {
            backgroundColor: 'rgba(0, 0, 0, 0.5)'
          }
        }
      }}
    >
      <DialogTitle
        sx={{
          px: 3,
          py: 2,
          fontWeight: 400,
          fontSize: 18,
          color: 'text.primary'
        }}
      >
        {label}
      </DialogTitle>

      <DialogContent
        sx={{
          px: 3,
          py: 1.5,
          display: 'flex',
          alignItems: 'flex-start'
        }}
      >
        {message && (
          <Typography variant="body1">
            {message}
            {entityName && (
              <>
                <Typography component="span" fontWeight={600} color="text.primary">
                  {entityName}
                </Typography>
                ?
              </>
            )}
          </Typography>
        )}
        {children}
      </DialogContent>

      <DialogActions sx={{ px: 3, py: 2 }}>
        <GenericButton buttonType={GenericButtonTypeEnum.Neutral} variant="text" onClick={onClose} label={closeLabel ?? 'Cancel'} />
        {confirmLabel && onConfirm && (
          <GenericButton
            label={confirmLabel}
            buttonType={GenericButtonTypeEnum.Primary}
            sx={{
              backgroundColor: confirmColor ?? '#D32F2F',
              borderRadius: '10px',
              '&:hover': {
                backgroundColor: confirmColor ? darken(confirmColor, 0.2) : '#b71c1c'
              }
            }}
            onClick={onConfirm}
          />
        )}
      </DialogActions>
    </Dialog>
  );
};

export default GenericInfoModal;
